export enum DoctorMutationKey {
  AuthToken = 'doctor/token',
  AssignExaminations = 'doctor/assignExaminations',
  AssignVisits = 'doctor/assignVvisits',
  ExaminationShareLink = 'doctor/examination/shareLink',
}
